import { useState } from "react";
import algoliaSearch from "algoliasearch/lite";
import aa from "search-insights";
import { InstantSearch, Configure } from "react-instantsearch-dom";
import { PropTypes } from "prop-types";

import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import CustomSearchUI from "./searchPopup/CustomSearchUI";

import { useCurrentCountryCode } from "../../hooks/usePrices";
import { useCurrentLang } from "../../hooks/useLocalizedCartInfo";
import { getAlgoliaIndexBaseKey } from "../../../locale-shopifies";

const searchClient = algoliaSearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_API_KEY
);

aa("init", {
  appId: process.env.GATSBY_ALGOLIA_APP_ID,
  apiKey: process.env.GATSBY_ALGOLIA_SEARCH_API_KEY,
});

function SearchPopup({ closeSearch }) {
  const [sortBy, setSortBy] = useState("");

  const countryCode = useCurrentCountryCode();
  const lang = useCurrentLang();
  const indexKey = getAlgoliaIndexBaseKey(countryCode, lang);
  const sortByOptions = {
    "": "default",
    all: "default",
    new: "new-arrivals",
    low_high: "price-low-high",
    high_low: "price-high-low",
  };
  const sort = sortByOptions[sortBy] || "default";
  const index = sort === "default" ? `products-${indexKey}` : `products-${indexKey}-${sort}`;

  return (
    <InstantSearch searchClient={searchClient} indexName={index}>
      <Configure clickAnalytics />
      <div className="fixed left-0 right-0 top-0 bg-white">
        <CustomSearchUI
          sortBy={sortBy}
          onChangeSortBy={setSortBy}
          indexName={index}
          closeSearch={closeSearch}
        />
      </div>
    </InstantSearch>
  );
}
SearchPopup.propTypes = {
  closeSearch: PropTypes.func,
};

export default withALErrorBoundary({
  name: "SearchPopup",
  priority: "P2",
})(SearchPopup);
